import React from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  // Function to close navbar on link click
  const closeMenu = () => {
    const menu = document.getElementById("main_nav");
    if (menu && menu.classList.contains("show")) {
      // Bootstrap collapse close
      const bsCollapse = window.bootstrap.Collapse.getInstance(menu);
      if (bsCollapse) {
        bsCollapse.hide();
      }
    }
  };

  const location = useLocation();

  return (
    <div>
      <div className="header-top">
        <div className="container">
          <div className="header-top-wrapper">
            <div className="header-top-left">
              <div className="header-top-contact">
                <ul>
                  <li>
                    <a href="tel:+919918001880">
                      <i className="far fa-phone-volume"></i> {" "} +91
                       9415003780 | 9918001880
                    </a>
                  </li>

                  <li>
                    <a href="mailto:orientelevators@refiffmail.com">
                      <i className="far fa-envelopes"></i> {" "}
                      orientelevators@refiffmail.com
                    </a>
                  </li>

                  {/* <li>
//                       <a href="#">
//                         <i className="far fa-map-marker-alt"></i> Sector-17,
//                         Indira Nagar, Lucknow, UP 226016
//                       </a>
//                     </li> */}
                </ul>
              </div>
            </div>

            <div className="header-top-right">
              <div className="header-top-social">
                <span>Follow Us: </span>

                <a href="#">
                  <i className="fab fa-facebook"></i>
                </a>

                <a href="#">
                  <i className="fab fa-twitter"></i>
                </a>

                <a href="#">
                  <i className="fab fa-instagram"></i>
                </a>

                <a href="#">
                  <i className="fab fa-linkedin"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="main-navigation">
        <nav className="navbar navbar-expand-lg">
          <div className="container position-relative">
            {/* ✅ Logo */}
            <Link to="/" className="navbar-brand" onClick={closeMenu}>
              <img src="assets/img/logo/logo.png" alt="logo" />
            </Link>

            {/* ✅ Mobile Toggle Button */}
            <div className="mobile-menu-right">
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#main_nav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-mobile-icon">
                  <i className="far fa-bars"></i>
                </span>
              </button>
            </div>

            {/* ✅ Menu Items */}
            <div className="collapse navbar-collapse" id="main_nav">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/" ? "active" : ""
                    }`}
                    to="/"
                    onClick={closeMenu}
                  >
                    Home
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/about" ? "active" : ""
                    }`}
                    to="/about"
                    onClick={closeMenu}
                  >
                    About Us
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/Service" ? "active" : ""
                    }`}
                    to="/Service"
                    onClick={closeMenu}
                  >
                    Services
                  </Link>
                </li>

                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/Contactus" ? "active" : ""
                    }`}
                    to="/Contactus"
                    onClick={closeMenu}
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
